<template>
	<Features
		:page="page"
		:title="title"
		:subTitle="subTitle"
		:filterBy="filterBy"
		:idsToShow="idsToShow"
		@show-wizard="showWizard"
		:canCreateNew="canCreateNew"
		:showButtonDropdowns="showButtonDropdowns"
	/>
</template>

<script>
import { AccountPermissions, ProjectPermissions } from '@ply-io/ply-front-shared-utilities';

import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import AnalyticsService from '@/utils/AnalyticsService';
import { VIRTUAL_PROJECT_IDS } from '@/utils/projects.const';
import Features from '@/views/AppContentPages/Features.vue';
export default {
	name: 'SpaceFeaturesDataProvider',
	props: {
		title: { type: String },
		subTitle: { type: String },
		idsToShow: { type: Array },
		page: { type: Number, default: 1 },
		featureType: { type: [String, Array] },
		showButtonDropdowns: { type: Boolean },
	},
	components: { Features },
	computed: {
		...mapGettersShorthand({ selectedProjectId, projectHasPermission, hasAccountPermission }),
		filterBy() {
			if (this.featureType) {
				return { feature_type: this.featureType };
			}
			return null;
		},
		canCreateNew() {
			if (!this.hasAccountPermission(AccountPermissions.CreateWorkflows)) {
				return false;
			}

			if (this.projectToCreateWorkflowIn) {
				return this.projectHasPermission(this.selectedProjectId, ProjectPermissions.ChangeWorkflows);
			}
			return true;
		},
		projectToCreateWorkflowIn() {
			return VIRTUAL_PROJECT_IDS.includes(this.selectedProjectId) ? undefined : Number(this.selectedProjectId);
		},
	},
	methods: {
		showWizard() {
			AnalyticsService.trackButtonClicked(AnalyticsService.BUTTONS.CREATE_NEW_FEATURE, {});

			AppDialogManagerService.openCreationWizardDialog({
				initialState: {
					selectedTabIndex: 0,
					projectId: this.projectToCreateWorkflowIn,
				},
			});
		},
	},
};
</script>
<style scoped lang="scss"></style>
